import React, { useEffect, useMemo, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { BackButton, CancelIcon, SearchesCIcon } from "../assets/Icons";
import apiClient from "../apiClient";
import { SSO_URL } from "../env";
import { GET_GROUP_LIST } from "../apiClient/apiEndpoints";
import { setDefaultTextForImage } from "../components/common/DefaulTextForAvatar";
import NoDataFound from "../components/common/NoDataFound";

const Groups = ({ search = "", setSearch = "", setNewChannelDetails, newChannelDetails }) => {
  const [staticRender, setStaticRender] = useState(true);
  const [groups, setGroups] = useState([]);

  const fetchGroups = async () => {
    const response = await apiClient.get(`${SSO_URL}${GET_GROUP_LIST}`);
    setGroups(response);
    setStaticRender(false);
  };

  const staticTileCards = Array.from({ length: 4 }, (_, i) => (
    <div key={`static-tile-${i}`} className="tilecard p-0 mb-3" style={{ outline: "none" }}>
      <div className="groupcardesign">
        <div className="avatarimg p-0" style={{ outlineColor: "#ffffff00" }}>
          <Skeleton count={1} circle height="100%" width="100%" className="m-0 p-0" />
        </div>
        <h6 className="groupname"> </h6>
        <div className="groupusercount d-flex flex-column gap-2">
          <p>
            <Skeleton width="10vw" className="my-1" />{" "}
          </p>
          <p>
            <Skeleton width="10vw" className="my-1" />{" "}
          </p>
        </div>
      </div>
    </div>
  ));

  const filterGroups = useMemo(() => {
    if (!search) return groups;
    return groups.filter((e) => e?.name?.toLowerCase()?.includes(search?.toLowerCase()));
  }, [search, groups?.length]);

  useEffect(() => {
    fetchGroups();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-lg-6 mt-3">
          <span className="list-tag mt-4 standardinput">
            {" "}
            <label>
              {" "}
              Select Group<span>*</span>{" "}
            </label>{" "}
          </span>
          {!newChannelDetails.group && <p className="error"> Select Group. </p>}
        </div>
        <div className="col-lg-6 d-flex align-items-center justify-content-end"></div>
      </div>
      <div className="courses-parent usergrouplist mt-2">
        <div className="group-title">
          <form className=" app-search app-search1 d-flex justify-content-start me-2">
            <div className="position-relative">
              <SearchesCIcon />
              {search.length > 0 && (
                <span className="searchiconcancel" onClick={() => setSearch("")}>
                  {" "}
                  <CancelIcon />
                </span>
              )}
              <input
                type="text"
                name="searchName"
                className="form-control"
                placeholder="Search"
                autoComplete="off"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </form>
        </div>
        {staticRender ? (
          <div className="course-tiles mt-2">{staticTileCards}</div>
        ) : (
          <>
            {filterGroups.length > 0 ? (
              <div className="course-tiles mt-2">
                {filterGroups?.map((item) => {
                  return (
                    <div
                      onClick={() => setNewChannelDetails((prev) => ({ ...prev, group: item.uuid }))}
                      className={
                        newChannelDetails.group == item.uuid ? "tilecard selected-group p-0 mb-3" : "tilecard  p-0 mb-3"
                      }
                    >
                      <div className="groupcardesign">
                        <div className="avatarimg">
                          {item?.avatar ? (
                            <img
                              src={item?.avatar}
                              alt={`Avatar for Simulanis`}
                              title="Simulanis"
                              referrerPolicy={"no-referrer"}
                            />
                          ) : (
                            <span>{setDefaultTextForImage(item?.name)}</span>
                          )}
                        </div>
                        <h6 className="groupname"> {item?.name} </h6>
                        {/* <div className="groupusercount">
                        <p>
                          36 Sub-Groups <span className="mx-1">|</span>
                        </p>
                        <p> 33 Users </p>
                      </div> */}
                        {/* <div className="d-flex align-items-center justify-content-center gap-2">
                        <span className="select-group">Selected</span>
                        <span className="more-groups">View Subgroups</span>
                      </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <NoDataFound text="No group found"/>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Groups;
